const namespace = "IPINFORMATION_";

export default {
  SET_LOADING: `${namespace}SET_LOADING`,
  GET_COUNTRY_CODE: `${namespace}GET_COUNTRY_CODE`,
  GET_COUNTRY_CODE_SUCCESS: `${namespace}GET_COUNTRY_CODE_SUCCESS`,
  SET_COUNTRY: `${namespace}SET_COUNTRY`,
  SET_COUNTRY_LIST_BOTTOMSHEET: `${namespace}SET_COUNTRY_LIST_BOTTOMSHEET`,
};
